import React from 'react';

import useTicketsReadStatus from './hooks/useTicketsActionDropDown'; // Import the custom hook
import { FlexContainerStyled, TicketsStatusSelectStyled } from './TicketActionDropDown.styled';
import ErrorSection from 'components/ErrorSection/ErrorSection';
import Popup from 'components/Popup/Popup';
import Select from 'components/Select/Select';
import { SelectOptionT } from 'declarations/types/select';

interface SelectProps {
  selectedTicketsIds: string[];
}

const TicketsReadStatusSelect: React.FC<SelectProps> = ({ selectedTicketsIds }) => {
  const options: SelectOptionT[] = [
    { value: 'read', label: 'Mark Read' },
    { value: 'unread', label: 'Mark Unread' },
  ];

  const {
    errorIsVisible,
    selectedOption,
    isPopupOpen,
    readStatusTicketErrorMessage,
    unreadStatusTicketErrorMessage,
    handleOptionChange,
    handlePopupOpen,
    handlePopupClose,
  } = useTicketsReadStatus({ selectedTicketsIds });

  return (
    <TicketsStatusSelectStyled>
      {(errorIsVisible || readStatusTicketErrorMessage || unreadStatusTicketErrorMessage) && (
        <Popup
          showCloseBtn
          isOpen={isPopupOpen}
          onOpen={handlePopupOpen}
          onClose={handlePopupClose}
        >
          <FlexContainerStyled direction="column">
            <ErrorSection />
          </FlexContainerStyled>
        </Popup>
      )}
      <Select
        options={options}
        isDisabled={selectedTicketsIds.length === 0}
        value={selectedOption.value}
        onChange={newValue => handleOptionChange(newValue as SelectOptionT | null)}
        placeholder={selectedTicketsIds.length > 0 ? selectedTicketsIds.length.toString() : '▢'}
      />
    </TicketsStatusSelectStyled>
  );
};

export default TicketsReadStatusSelect;
